module.exports = __webpack_public_path__ + "static/media/overview4_0.c2cefdc4.png";